import React, { useContext, useEffect } from 'react'
import { Link } from 'gatsby';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

import { StoreContext } from '../../../context/store-context';
import upsellSellingGroups from '../../../utils/sellingPlanGroups/upsellSellingGroups';

const UpsellBundlePreviewV2 = ({
  upsellBundleResultHandle,
  upsellBundleViewProductHandle,
  upsellBundleProductPrice = 16.15,
  upsellBundleResultVariantTitle,
  upsellBundleViewDescription,
  upsellBundleCategory,
  upsellAddonProductHandle,
  upsellAddonCategory,
  upsellAddonProductPrice,
  upsellAddonProductDescription,
  frequencyText,
  closeCart,
  item,
  cart,
  replaceCartItem,
}) => {
  const { allProducts, addVariantToCart } = useContext(StoreContext);
  const upsellBundleResult = allProducts.find(
    (item) => item.handle === upsellBundleResultHandle
  );
  const upsellBundleViewProduct = allProducts.find(
    (item) => item.handle === upsellBundleViewProductHandle
  );
  const upsellBundleResultVariantId = upsellBundleResultVariantTitle
    ? upsellBundleResult.variants.find(
      (variant) => variant.title === upsellBundleResultVariantTitle
    )?.storefrontId
    : upsellBundleResult.variants[0].storefrontId;
  const isSubscriptionUpsell = item.node.sellingPlanAllocation !== null;

  const discount =
    upsellBundleProductPrice &&
    upsellBundleViewProduct &&
    Math.floor(
      (1 -
        Number(upsellBundleProductPrice) /
        Number(upsellBundleViewProduct.variants[0].price)) *
      100
    );

  const addUpsell = async () => {
    const allSellingPlanGroups = await upsellSellingGroups(
      upsellBundleResult.storefrontId
    );
    const sellingPlanGroups =
      allSellingPlanGroups.product.sellingPlanGroups.edges[0] &&
      allSellingPlanGroups.product.sellingPlanGroups.edges[0].node
        .sellingPlans.edges;
    const correctSellingPlan =
      sellingPlanGroups &&
        sellingPlanGroups.filter(
          (item) => item.node.name === frequencyText
        ).length
        ? sellingPlanGroups.filter(
          (item) => item.node.name === frequencyText
        )
        : null;

    replaceCartItem(
      cart.id,
      item,
      item.node.merchandise.id,
      item.node.id,
      upsellBundleResultVariantId,
      [],
      item.quantity,
      correctSellingPlan ? correctSellingPlan[0].node.id : null
    );
  };

  const upsellAddonProduct = allProducts.find(
    (item) => item.handle === upsellAddonProductHandle
  );
  const discountAddon = Math.floor(
    (1 -
      Number(upsellAddonProductPrice) /
      Number(upsellAddonProduct?.variants[0]?.price)) *
    100
  );
  const addUpsellAddon = async () => {
    const allSellingPlanGroups = await upsellSellingGroups(
      upsellAddonProduct.storefrontId
    );
    const sellingPlanGroups =
      allSellingPlanGroups.product.sellingPlanGroups.edges[0].node
        .sellingPlans.edges;
    const correctSellingPlan = sellingPlanGroups.filter(
      (item) => item.node.name === frequencyText
    ).length
      ? sellingPlanGroups.filter(
        (item) => item.node.name === frequencyText
      )
      : sellingPlanGroups;
    addVariantToCart(
      upsellAddonProduct?.variants[0]?.storefrontId,
      1,
      [],
      false,
      upsellAddonProduct,
      correctSellingPlan[0].node.id
    );

    const cartItemsContainer = document.getElementById('cart-items');
    if (cartItemsContainer) {
      cartItemsContainer.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  };

  const isAlreadyAddonInCart = cart?.lines?.edges?.some(
    (item) => item?.node?.merchandise?.product?.handle === upsellAddonProductHandle
  );

  return (
    <span id='upsell-bundle-v2' className='cart-item-bundle v2-upsell hidden-ab-v2'>
      <p>Josh recommends to...</p>

      {upsellBundleViewProduct && (
        <span className='cart-item v2-upsell'>
          {upsellBundleViewProduct.media[0] && (
            <Link
              to={`/products/${upsellBundleViewProductHandle}`}
              className='cart-item__img v2-upsell__img'
              onClick={closeCart}
            >
              <LazyLoadImage
                src={
                  upsellBundleViewProduct.media[0].preview.image
                    .originalSrc
                }
                alt={upsellBundleViewProduct.title}
                effect='blur'
              />
            </Link>
          )}
          <div className='cart-item__content'>
            <div className='cart-item-bundle__subtitle--v2'>{upsellBundleCategory}</div>
            <div className='cart-item-bundle__title--v2'>
              {upsellBundleViewProduct.title} £ {isSubscriptionUpsell
                ? upsellBundleProductPrice
                : upsellBundleViewProduct.variants[0].price}{' '}

              <span className='cart-item-bundle__title--v2__discount'>
                SUBSCRIBE AND SAVE {discount}%
              </span>

            </div>
            <div className='cart-item-bundle__description--v2'>
              {upsellBundleViewDescription}
            </div>
            <button
              onClick={addUpsell}
              className='cart-item-bundle__button button button--purple'
            >
              add to my subscription
            </button>
          </div>
        </span>
      )}

      {upsellAddonProduct && !isAlreadyAddonInCart && (
        <span className='cart-item v2-upsell'>
          {upsellAddonProduct.media[0] && (
            <Link
              to={`/products/${upsellAddonProduct}`}
              className='cart-item__img v2-upsell__img'
              onClick={closeCart}
            >
              <LazyLoadImage
                src={
                  upsellAddonProduct.media[0].preview.image
                    .originalSrc
                }
                alt={upsellAddonProduct.title}
                effect='blur'
              />
            </Link>
          )}
          <div className='cart-item__content'>
            <span className='cart-item__content__tag'>NEW</span>
            <div className='cart-item-bundle__subtitle--v2'>{upsellAddonCategory}</div>
            <div className='cart-item-bundle__title--v2'>
              {upsellAddonProduct.title} £ {upsellAddonProductPrice}{' '}

              <span className='cart-item-bundle__title--v2__discount'>
                SUBSCRIBE AND SAVE {discountAddon}%
              </span>

            </div>
            <div className='cart-item-bundle__description--v2'>
              {upsellAddonProductDescription}
            </div>
            <button
              onClick={addUpsellAddon}
              className='cart-item-bundle__button button button--purple'
            >
              add to my subscription
            </button>
          </div>
        </span>
      )}
    </span>
  )
}

export default UpsellBundlePreviewV2